export default __webpack_public_path__ + "static/media/relic_from_guyun.c9c73356.png";